"use client";

import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Globe, Shield, Zap, BarChart3, Cpu, Network } from "lucide-react";
export default function InternationalVenturesExportArchitecture() {
  const [isAnimating, setIsAnimating] = useState(false);
  useEffect(() => {
    const timer = requestAnimationFrame(() => {
      setIsAnimating(true);
    });
    return () => cancelAnimationFrame(timer);
  }, []);
  const pillars = [{
    icon: Globe,
    label: "Global Presence"
  }, {
    icon: Shield,
    label: "Secure Logistics"
  }, {
    icon: Zap,
    label: "Rapid Execution"
  }, {
    icon: BarChart3,
    label: "Market Intel"
  }, {
    icon: Cpu,
    label: "Digital Core"
  }, {
    icon: Network,
    label: "Nexus Network"
  }];
  return <section id="international-ventures-export-architecture" className="relative flex min-h-[700px] h-screen w-full items-center justify-center overflow-hidden bg-[#EAEAEA]">
      {}
      <div className="absolute inset-0 z-0 bg-[#EAEAEA]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 z-10 bg-white/5 mix-blend-overlay" aria-hidden="true" />
      
      <div className="relative z-20 flex w-full max-w-7xl flex-col items-center justify-between gap-12 px-6 lg:flex-row lg:text-left">
        {}
        <div className="flex flex-col items-center text-center lg:w-1/2 lg:items-start lg:text-left">
          <h1 className="mb-6 max-w-2xl font-serif text-5xl font-bold uppercase leading-tight tracking-tight text-[#0F172A] md:text-7xl">
            Geroi.eu: International Ventures & Export Architecture.
          </h1>

          <p className="mb-12 font-sans text-xl font-medium uppercase tracking-[6px] text-[#475569] md:text-2xl">
            Strategy. Vision. Domination.
          </p>

          <Link to="#access-the-network">
            <Button size="lg" className="group relative h-auto overflow-hidden rounded-none border-none bg-gradient-to-r from-[#D4AF37] via-[#F1D37E] to-[#B8860B] bg-[length:200%_100%] px-12 py-6 font-sans text-xl font-bold text-[#0F172A] shadow-xl shadow-[#D4AF37]/20 transition-all duration-500 hover:bg-[position:100%_0] hover:shadow-[#D4AF37]/40">
              Connect with Us
            </Button>
          </Link>
        </div>

        {}
        <div className="relative w-full max-w-xl lg:w-1/2">
          {}
          <div className="absolute -inset-4 animate-pulse rounded-none bg-[#2563EB]/20 blur-3xl" />
          
          <div className="relative overflow-hidden border border-white/50 bg-white/40 p-1 backdrop-blur-2xl shadow-2xl">
            <div className="relative aspect-square w-full overflow-hidden bg-[#EAEAEA]">
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591123/img/architectural_vision_structure.png" alt="Architectural Vision" className={`h-full w-full object-cover transition-transform duration-[10000ms] ease-out ${isAnimating ? "scale-110" : "scale-100"}`} />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent" />
              
              {}
              <svg className="absolute inset-0 h-full w-full" viewBox="0 0 400 400">
                <defs>
                  <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#2563EB" stopOpacity="0.8" />
                    <stop offset="100%" stopColor="#2563EB" stopOpacity="0.2" />
                  </linearGradient>
                </defs>
                
                {}
                <g className="stroke-[#2563EB]/40 stroke-[1.5] fill-none">
                  <path d="M100,100 L300,300" className="animate-[dash_3s_linear_infinite]" strokeDasharray="10,10" />
                  <path d="M300,100 L100,300" className="animate-[dash_3s_linear_infinite_reverse]" strokeDasharray="10,10" />
                  <circle cx="200" cy="200" r="150" className="opacity-20" />
                </g>
              </svg>

              {}
              <div className="absolute inset-0 grid grid-cols-3 grid-rows-2 gap-4 p-8">
                {pillars.map((pillar, i) => <div key={i} data-index={i} className="group flex flex-col items-center justify-center space-y-2 border border-[#2563EB]/30 bg-white/60 p-4 backdrop-blur-md transition-all duration-500 hover:bg-[#2563EB] hover:shadow-[0_0_20px_rgba(37,99,235,0.4)]">
                    <pillar.icon className="h-8 w-8 text-[#2563EB] transition-colors duration-500 group-hover:text-white" />
                    <span className="text-[10px] font-bold uppercase tracking-widest text-[#0F172A] group-hover:text-white">
                      {pillar.label}
                    </span>
                  </div>)}
              </div>

              {}
              <div className="absolute bottom-4 right-4 h-2 w-24 bg-[#2563EB] shadow-[0_0_15px_#2563EB]" />
              <div className="absolute top-4 left-4 h-12 w-1 bg-[#2563EB] shadow-[0_0_15px_#2563EB]" />
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes dash {
          to {
            stroke-dashoffset: -20;
          }
        }
      `}</style>
    </section>;
}